export const formatPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber)
    return ''

  return phoneNumber.replace(/[^\d]/g, '').replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
}